import {
  http_fibercloud,
  http_fibercloud_complete_request,
  http_weezie_fiber,
  http_field_license,
  http_fibercloud_license,
} from "./index";
import AccessControl from "./accessControl";
import Company from "./company";
import User from "./user";
import Import from "./import";
import Delete from "./delete";
import Auth from "./auth";
import Workspace from "./workspace";
import Lists from "./lists";
import Export from "./export";
import GeoServer from "./geo_server";
import Layer from "./layer";
import NetworkObject from "@/api/network_object";
import Image from "./image";
import BestRoute from "./best_route";
import Cluster from "./cluster";
import WorkspaceDesign from "./workspace_design";
import ObjectForm from "./object_form";
import Materials from "./materials";
import NetworkRules from "./networkRules";
import License from "./license";
import Label from "./label";
import Processing from "@/api/processing";
import Dashboard from "@/api/dashboard";
import Splitters from "@/api/splitters";
import Splicing from "@/api/splicing";
import AssetReservation from "@/api/assetReservation";
import ChangeLog from "@/api/changeLog";
import Tickets from "@/api/tickets";
import ClientRoles from "./client_roles";
import ActivitiesAndTasks from "@/api/activities_and_tasks";
import TwoFactorsAuthentications from "@/api/two_factor_authentication";
import Integrations from "@/api/integrations";
import Consumables from "@/api/consumables";
import Modules from "@/api/modules";
import Licenses from "@/api/licenses";
import CustomListsAndFields from "@/api/customListsAndFields";
import Network from "@/api/network";
import WorkOrders from "@/api/workOrders";
import BuildingVerticalPlanning from "@/api/buildingVerticalPlanning";
import PathwayMicroducts from "@/api/pathwayMicroducts";
import EmailRecovery from "./emailRecovery";
import Simulations from "./simulations";

export default class APIFC {
  constructor() {
    this.http_fibercloud = http_fibercloud;
    this.http_weezie_fiber = http_weezie_fiber;
    this.http_fibercloud_complete_request = http_fibercloud_complete_request;
    this.http_field_license = http_field_license;
    this.http_fibercloud_license = http_fibercloud_license;
    this.emailRecovery = new EmailRecovery(this);
    this.simulations = new Simulations(this);
    this.acl = new AccessControl(this);
    this.company = new Company(this);
    this.user = new User(this);
    this.import = new Import(this);
    this.delete = new Delete(this);
    this.auth = new Auth(this);
    this.workspace = new Workspace(this);
    this.lists = new Lists(this);
    this.export = new Export(this);
    this.geo_server = new GeoServer(this);
    this.layer = new Layer(this);
    this.networkObject = new NetworkObject(this);
    this.image = new Image(this);
    this.best_route = new BestRoute(this);
    this.cluster = new Cluster(this);
    this.workspace_design = new WorkspaceDesign(this);
    this.object_form = new ObjectForm(this);
    this.materials = new Materials(this);
    this.networkRules = new NetworkRules(this);
    this.license = new License(this);
    this.label = new Label(this);
    this.processing = new Processing(this);
    this.dashboard = new Dashboard(this);
    this.splitters = new Splitters(this);
    this.splicing = new Splicing(this);
    this.assetReservation = new AssetReservation(this);
    this.changeLog = new ChangeLog(this);
    this.tickets = new Tickets(this);
    this.clientRoles = new ClientRoles(this);
    this.activitiesAndTasks = new ActivitiesAndTasks(this);
    this.twoFactorAuthentication = new TwoFactorsAuthentications(this);
    this.integrations = new Integrations(this);
    this.consumables = new Consumables(this);
    this.modules = new Modules(this);
    this.licenses = new Licenses(this);
    this.customListsAndFields = new CustomListsAndFields(this);
    this.network = new Network(this);
    this.workOrders = new WorkOrders(this);
    this.buildingVerticalPlanning = new BuildingVerticalPlanning(this);
    this.pathwayMicroducts = new PathwayMicroducts(this);
  }
}



// WEBPACK FOOTER //
// ./src/api/APIFC.js